import styled from "vue-styled-components";
import { themeProps } from "./ThemeProps";
import ReadStyleGuide from "./ReadStyleGuide";
import { media } from "./MediaSizes";

export const sSpan = styled("span", themeProps)`
  color: ${props => props.color || ReadStyleGuide.color.darkBlue};
  font-style: ${props => props.fontStyle || "initial"};
  font-family: ${props =>
    props.fontFamily || null};
  font-size: ${props => props.fontSize || null};
  line-height: ${props => props.lineHeight || "1"};
  text-align: ${props => props.textAlign || "center"};
  white-space: ${props => props.whiteSpace || "normal"};
  ${props => (props.border ? `border: ${props.border}` : null)};
  ${props => (props.width ? `width: ${props.width}` : null)};
  ${props => (props.margin ? `margin: ${props.margin}` : null)};
  ${props =>
    props.textDecoration ? `text-decoration: ${props.textDecoration}` : null};
  ${props => (props.padding ? `padding: ${props.padding}` : null)};
  ${props => (props.fontWeight ? `font-weight: ${props.fontWeight}` : null)};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : null)};

  &:hover {
    color: ${props => props.hoverColor || null};
    cursor: ${props => props.cursorType || null};
}

  ${media.desktop`
    font-size: ${props => props.tabletFontSize}; 
    text-align: ${props => props.deskotpTextAlign}
  `}
  ${media.tablet`
    font-size: ${props => props.smallTabletFontSize};
  `}
  ${media.phone`
    font-size: ${props => props.mobileFontSize};
  `}
`;
